// ret menu fix (12 Oct 2026): in the All products dropdown only one group is open at a time,
// and closing All products closes its groups so it reopens tidy.
document.addEventListener('toggle', (e) => {
  const d = e.target;
  if (!(d instanceof HTMLDetailsElement)) return;
  const close = (o) => { o.removeAttribute('open'); const s = o.querySelector(':scope > summary'); if (s) s.setAttribute('aria-expanded', 'false'); };
  if (d.id.startsWith('Details-HeaderMenu-') && !d.open) {
    d.querySelectorAll('details[id^="Details-HeaderSubMenu-"][open]').forEach(close);
  } else if (d.id.startsWith('Details-HeaderSubMenu-') && d.open) {
    const list = d.closest('.list-menu--disclosure');
    if (list) list.querySelectorAll('details[id^="Details-HeaderSubMenu-"][open]').forEach((o) => { if (o !== d) close(o); });
  }
}, true);
